@if (data) {
<div class="row">
  <div class="col-sm-6 flex justify-content-end">
    <div class="row">
      <div class="col-sm-12" style="padding-left: 19px; padding-right: 15px">
        <img
          [src]="data.data.image"
          class="img-fluid-product"
          alt="impleblog"
        />
      </div>
    </div>
  </div>
  <div class="col-sm-6 flex justify-content-center">
    <div class="row">
      <div class="col-sm-12">
        <!-- header -->
        @if(country=='cl'){
        <a href="https://www.implementos.cl/sitio/blog" id="blog-title">
          <div
            class="titleBlog"
            style="text-align: center; margin-bottom: 1.8rem"
          >
            <h2 class="text-h1">
              {{ data.data.title | uppercase }}
            </h2>
            <h3 class="text-h2">
              {{ data.data.description }}
            </h3>
          </div>
        </a>
        } @else if(country=='es'){
        <a href="https://www.implementos.eu/sitio/blog" id="blog-title">
          <div
            class="titleBlog"
            style="text-align: center; margin-bottom: 1.8rem"
          >
            <h2 class="text-h1">
              {{ data.data.title | uppercase }}
            </h2>
            <h3 class="text-h2">
              {{ data.data.description }}
            </h3>
          </div>
        </a>
        } @else{
        <a href="https://www.implementos.com.pe/sitio/blog" id="blog-title">
          <div
            class="titleBlog"
            style="text-align: center; margin-bottom: 1.8rem"
          >
            <h1 class="text-h1">
              {{ data.data.title | uppercase }}
            </h1>
            <h4 class="text-h2">
              {{ data.data.description }}
            </h4>
          </div>
        </a>
        } @for (item of blogs; track $index) {
        <div
          id="accordion"
          style="border-bottom: 3px solid #0d61bb; padding: 1.7rem 0"
        >
          <!-- Start::header entrada blog -->
          <div
            class="row"
            style="cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-target]="'#expand-' + $index"
            [attr.aria-expanded]="item.collapsed"
            [attr.aria-controls]="'expand-' + $index"
            (click)="clickCollapse($index)"
          >
            <div class="col-sm-10" style="display: flex; align-items: center">
              <h4 class="text-titulo">
                {{ $index + 1 }}. {{ item.title | uppercase }}
              </h4>
            </div>
            <div
              class="col-sm-2"
              style="text-align: right; padding-right: 2rem"
            >
              <span
                class="fas fa-chevron-{{ item.collapsed ? 'down' : 'right' }}"
                style="cursor: pointer; color: #0d61bb"
              ></span>
            </div>
          </div>
          <!-- End::header entrada blog -->
          <!--  [class.show]="item.collapsed" -->
          <div
            class="collapse"
            [ngbCollapse]="!item.collapsed"
            style="padding-right: 3rem"
          >
            <p
              style="
                margin-top: 16px;
                overflow: hidden;
                color: black;
                font-size: 16px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; /* number of lines to show */
                line-clamp: 2;
                -webkit-box-orient: vertical;
              "
            >
              {{ item.titleDrop }}
            </p>
            <div
              style="
                text-align: right;
                padding: 0.1rem 0.5rem 0.1rem 0;
                font-size: 20px;
              "
            >
              <button
                class="btn btn-sm btn-secondary"
                (click)="showBlogPost(item.pageId, $index)"
              >
                Mostrar más
              </button>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
